class ProductSearch {

	init() {
		this.RefineSearch();
	}

	RefineSearch() {

    const select = document.getElementById('vkfs_product-cat');

    const checkboxwrap = document.querySelector('#vkfs_product-search');
    const checkboxblock = checkboxwrap.closest('.vkfs__outer-wrap');
    const checkboxitem = checkboxwrap.querySelectorAll('li');
    const checkbox = checkboxwrap.querySelectorAll('input[type="checkbox"]');

    let category = ['pipetter','regenerative','pipettetip','filtertip','dispopipette','tube','pcr','special_plate','measuring_plate','bloodresearch','cellculture','testplate','rack_stand_case','reagent','other'];

    let pipetter = ['mul2-70','mul100-500','mul1000-5000','ml10-50'];
    let regenerative = [];
    let pipettetip = ['mul10','mul200_250','mul300','mul1000_1200','ml5_10','length-short','length-normal','length-long','length-exlong'];
    let filtertip = ['mul10','mul20','mul100_200','mul300','mul1000_1200','ml5_10','length-short','length-normal','length-long','length-exlong'];
    let dispopipette = ['ml1-19','ml2-29','ml3-49','ml5-','㎜-150','㎜151-200','㎜201from'];
    let tube = ['ml05-10','ml15','ml20','ml3-12','ml15-50','ml60-150','ml250from','tube-flat','tube-round','tube-conical','tube-alone'];
    let pcr = ['ml01','ml02','ml06','well96','well384'];
    let special_plate = ['well1','well3','well96'];
    let measuring_plate = [];
    let bloodresearch = [];
    let cellculture = ['well6','well12','well24','well48','well96','well384'];
    let testplate = ['well6','well12','well24','well48','well96','well384'];
    let rack_stand_case = ['tube-ml05','tube-ml15','tube-ml20','pcrtube-ml01_02','cryotube-ml10_20','centrifuge-ml15_50'];
    let reagent = [];
    let other = [];


    // select change
    select.onchange = function() {
      console.log('doselect')
      if (this.value !== '') {
        let showCheckbox;

        switch (this.value) {

          case 'pipetter':
            showCheckbox = pipetter;
            break;

          case 'regenerative':
            showCheckbox = regenerative;
            break;

          case 'pipettetip':
            showCheckbox = pipettetip;
            break;

          case 'filtertip':
            showCheckbox = filtertip;
            break;

          case 'dispopipette':
            showCheckbox = dispopipette;
            break;

          case 'tube':
            showCheckbox = tube;
            break;

          case 'pcr':
            showCheckbox = pcr;
            break;

          case 'special-plate':
            showCheckbox = special_plate;
            break;

          case 'measuring-plate':
            showCheckbox = measuring_plate;
            break;

          case 'bloodresearch':
            showCheckbox = bloodresearch;
            break;

          case 'cellculture':
            showCheckbox = cellculture;
            break;

          case 'testplate':
            showCheckbox = testplate;
            break;

          case 'rack-stand-case':
            showCheckbox = rack_stand_case;
            break;

          case 'reagent':
            showCheckbox = reagent;
            break;

          case 'other':
            showCheckbox = other;
            break;

          default:
            break;
        }

        if( showCheckbox.length !== 0 ) {
          checkboxblock.style.display = 'flex';
          for (let i = 0; i < checkbox.length; i += 1) {
            const element = checkbox[i];
            const wrap = checkboxitem[i];
            element.checked = false;

              if( showCheckbox.includes(element.value) ) {
                wrap.style.display = 'block';
              } else {
                wrap.style.display = 'none';
              }
          }
        } else {
          checkboxblock.style.display = 'none';
          for (let i = 0; i < checkbox.length; i += 1) {
            const element = checkbox[i];
            const wrap = checkboxitem[i];
            element.checked = false;
            wrap.style.display = 'block';
          }
        }
      } else {
        checkboxblock.style.display = 'flex';
        for (let i = 0; i < checkbox.length; i += 1) {
          const element = checkbox[i];
          const wrap = checkboxitem[i];
          element.checked = false;
          wrap.style.display = 'block';
        }
      }
    }

    window.onload = function() {
      if (select.value !== '') {
        let showCheckbox;

        switch (select.value) {

          case 'pipetter':
            showCheckbox = pipetter;
            break;

          case 'regenerative':
            showCheckbox = regenerative;
            break;

          case 'pipettetip':
            showCheckbox = pipettetip;
            break;

          case 'filtertip':
            showCheckbox = filtertip;
            break;

          case 'dispopipette':
            showCheckbox = dispopipette;
            break;

          case 'tube':
            showCheckbox = tube;
            break;

          case 'pcr':
            showCheckbox = pcr;
            break;

          case 'special-plate':
            showCheckbox = special_plate;
            break;

          case 'measuring-plate':
            showCheckbox = measuring_plate;
            break;

          case 'bloodresearch':
            showCheckbox = bloodresearch;
            break;

          case 'cellculture':
            showCheckbox = cellculture;
            break;

          case 'testplate':
            showCheckbox = testplate;
            break;

          case 'rack-stand-case':
            showCheckbox = rack_stand_case;
            break;

          case 'reagent':
            showCheckbox = reagent;
            break;

          case 'other':
            showCheckbox = other;
            break;

          default:
            break;
        }

        if( showCheckbox.length !== 0 ) {
          checkboxblock.style.display = 'flex';
          for (let i = 0; i < checkbox.length; i += 1) {
            const element = checkbox[i];
            const wrap = checkboxitem[i];

              if( showCheckbox.includes(element.value) ) {
                wrap.style.display = 'block';
              } else {
                wrap.style.display = 'none';
              }
          }
        }
      }
    }

	}

}

export default ProductSearch;
